import React from "react";
import PropTypes from "prop-types";
import {ListItem, ListItemIcon, ListItemText} from "@material-ui/core";
import "./DrawerVault.css";
import { Link } from "react-router-dom";
import {useTheme} from "@material-ui/core/styles"
//import muiThemeable from "material-ui/styles/muiThemeable";

/**
 * Componente que sera parte de un grupo de opciones en un Drawer.
 */
const DrawerGroupItem = props => {
	const theme = useTheme()
	return (
		<Link to={props.toLink} className="noTextDeco" style={theme.menuItem}>
			<div className={props.className}>
				<ListItem button
					onClick={props.onTouchTap}
					//style={{ color: theme.palette.secondaryTextColor }}
					innerDivStyle={props.innerDivStyle}
				>
					<ListItemIcon>{props.icon}</ListItemIcon>
					<ListItemText	primary={props.textoItem}/>
				</ListItem>
			</div>
		</Link>
	);
};

DrawerGroupItem.propTypes = {
	toLink: PropTypes.string.isRequired,
	className: PropTypes.string,
	icon: PropTypes.node,
	textoItem: PropTypes.string,
	onTouchTap: PropTypes.func,
	innerDivStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

export default DrawerGroupItem//muiThemeable()(DrawerGroupItem);



// WEBPACK FOOTER //
// ./src/components/DrawerVault/DrawerGroupItem.js